import { PaymentCreateCustomerProfileDto, PaymentUpdateCustomerPaymentProfileDto, AnetCustomerProfileDto } from '@libs/dto';
import { api } from '../common.api';

export const paymentApi = api.injectEndpoints({
  endpoints: (build) => ({
    createCustomerProfile: build.mutation<void, PaymentCreateCustomerProfileDto>({
      query: (body) => ({
        url: '/payment/create-customer-profile',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CustomerProfile'],
    }),
    getCustomerProfile: build.query<AnetCustomerProfileDto, void>({
      query: () => ({
        url: '/payment/get-customer-profile',
        method: 'GET',
      }),
      providesTags: ['CustomerProfile'],
    }),
    createCustomerPaymentProfile: build.mutation<void, PaymentCreateCustomerProfileDto>({
      query: (body) => ({
        url: '/payment/create-customer-payment-profile',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CustomerPaymentProfile', 'CustomerProfile'],
    }),
    updateCustomerPaymentProfile: build.mutation<void, PaymentUpdateCustomerPaymentProfileDto>({
      query: (body) => ({
        url: '/payment/update-customer-payment-profile',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['CustomerPaymentProfile', 'CustomerProfile'],
    }),
    deleteCustomerPaymentProfile: build.mutation<void, string>({
      query: (id) => ({
        url: `/payment/delete-customer-payment-profile/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['CustomerPaymentProfile', 'CustomerProfile'],
    }),
  }),
})